import { useAuth } from '@amzn/dots-core-ui';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { CorePage, CorePageTitle } from '$/components';
import { HostDetailUri, HostsUri, RootUri } from '$/features/routes';
import { HostData } from '@amzn/dots-host-agent-management-service-client';
import { getHamsClient, getHost } from '$/api/client/client';
import { HostForm } from './components';

export function HostEditPage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  // const { openToast } = useToaster();

  const [host, setHost] = useState<HostData | undefined>(undefined);
  const auth = useAuth();

  useEffect(() => {
    async function fetchHost() {
      const hamsClient = await getHamsClient(auth);

      const response = await getHost({ accountName: id }, hamsClient);
      setHost(response?.host);
    }

    fetchHost();
  }, [auth, id]);

  const onSubmit = useCallback(() => {
    // TODO: link with new hams
    console.log('hello');
  }, []);

  return (
    <CorePage
      title="Edit"
      breadcrumbs={[
        { title: 'Scheduling', href: RootUri },
        { title: 'Host Agents', href: HostsUri },
        { title: host?.accountName ?? '', href: HostDetailUri(id) },
      ]}
      header={<CorePageTitle title={host ? `Edit ${host?.accountName}` : ''} />}
    >
      <HostForm
        onCancel={() => history.push(HostDetailUri(id))}
        onSubmit={onSubmit}
        host={host}
      />
    </CorePage>
  );
}
